/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
app.helpers = app.helpers || {};
(function ($) {
  'use strict';
  
  /**
   * Хелпер для кэширования шаблонов. Нужен чтобы не было утечек памяти.
   */
  app.helpers.TemplateHelper = {
    cache: {},
    getTemplate: function (templateName) {
      if (!this.cache[templateName] || app.HAS_KARMA) {
        this.cache[templateName] = _.template($(templateName).html() || '');
      }
      return this.cache[templateName];
    },
    getJson: function (jsonName) {
      var json = null;
      try {
        json = JSON.parse($(jsonName).html() || '');
      } catch (e) {
        return null;
      }
      return json;
    },
    /**
     * Если id=mask доступен, возвращает mask. В противном случае добавляем к mask случаное число и снова проверяем
     * @param mask
     * @returns {*}
     * @private
     */
    generateUniqId: function (mask) {
      if ($('#' + mask).length === 0) {
        return mask;
      } else {
        return this.generateUniqId(mask + '-' + _.random(1, 1000000, false));
      }
    }
  };
})(jQuery);

}.call(window));